export default __webpack_public_path__ + "static/media/default-avatar.fe4c4f3c.jpeg";